import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { HhsgSharedUserProfile } from '../../../models/user-profile.model';
import {LegacySideNavItemModel} from "../../models/legacy-side-nav-item.model";
import {HhsgSharedApplicationsService} from "../../../services";

@Component({
	selector: 'nav-item',
	templateUrl: 'nav-item.component.html',
	styleUrls: ['nav-item.component.scss']
})
export class NavItemComponent {
    @Input() item: LegacySideNavItemModel;
    @Input() sideNavOpened: boolean;
    @Input() user: HhsgSharedUserProfile;
    @Input() accordion: MatAccordion;
    @Output() sideNavOpenedChange = new EventEmitter<boolean>();

	constructor(
    private _sharedApplicationService: HhsgSharedApplicationsService,
    private ref: ChangeDetectorRef) {
    }

	public userCanAccessPage(menuItem: LegacySideNavItemModel) : boolean {
		if (menuItem?.roles) {
			let hasRoleResult = false;
			if (this.user) {
				menuItem.roles.forEach(role => {
					let userHasRole = this.hasRole(role, this.user.roles);
					if (userHasRole) {
						hasRoleResult = true;
					}
				});
			}
			return hasRoleResult;
		} else {
			return true;
		}
	}

  public async openApplicationLink(item: LegacySideNavItemModel) {
    this._sharedApplicationService.openChildUrlWithApplicationSpecificToken(item.name, item.applicationId, item.childApplicationUserId);
  }

  private hasRole(roleName: string, roles: string[]) : boolean {
      return roles && roles.findIndex(role => role == roleName) >= 0;
  }
}
